import { Box, Flex, Text } from '@chakra-ui/layout';
import { Fragment, useMemo } from 'react';
import { ReactComponent as Success } from '../../@core/assets/icons/ico_ok.svg';
import { ReactComponent as Error } from '../../@core/assets/icons/ico_error.svg';

export const Alert = ({
	title,
	subtitle,
	message,
	type = 'success',
	children
}) => {
	const icon = useMemo(() => {
		if (!type) return null;
		let iconType = null;

		switch (type) {
			case 'success':
				iconType = <Success />;
				break;
			case 'error':
				iconType = <Error />;
				break;
			default:
				return null;
		}
		return (
			<Box flex={1} width="100%" height={50} mt={13} mb={20}>
				{iconType}
			</Box>
		);
	}, [type]);

	return (
		<Fragment>
			<Flex
				backgroundColor="#F8FBFF"
				paddingY={12}
				borderTopRadius={12}
				minHeight={60}
				alignItems="center"
				justifyContent="center"
			>
				<Text
					as="div"
					fontSize={22}
					fontWeight="bold"
					color="#363B4D"
					marginBottom="0 !important"
					fontFamily="Poppins Bold"
				>
					{title ?? '¡Operación exitosa!'}
				</Text>
			</Flex>
			{icon}
			<Flex paddingX="1.5rem" flex="auto" minHeight="1" flexDirection="column">
				<Text color="#363B4D" fontSize={14} fontFamily="Poppins Regular">
					{subtitle}
				</Text>
				<Text
					color="#363B4D"
					fontSize={14}
					fontFamily="Poppins Regular"
					marginBottom="0 !important"
				>
					{message}
				</Text>
			</Flex>
			{children}
		</Fragment>
	);
};
